"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = memoize;

var _objectIs = require("./objectIs");

var _objectIs2 = _interopRequireDefault(_objectIs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns a wrapper function that, when called, either:
 *
 * 1. Returns a cached result if given the same args as the last time it was called, or
 * 2. If any args are different from last time, calls through to `func`
 *
 * @param {Function} func
 * @param {?Function} equalityFn A function of the form `(a, b) => <bool>`
 * @returns {Function}
 */
function memoize(func) {
  var equalityFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _objectIs2.default;

  var hasBeenCalled = false;
  var lastArgs = void 0;
  var lastResult = void 0;

  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (!hasBeenCalled || args.some(function (arg, i) {
      return !equalityFn(arg, lastArgs[i]);
    })) {
      hasBeenCalled = true;
      lastArgs = args;
      lastResult = func.apply(undefined, args);
    }
    return lastResult;
  };
};
module.exports = exports["default"];